export default angular
  .module("util.modal", [])
  .factory("modal", [
    "$modal",
    ($modal) => {
      const openDelete = (data, type) => $modal.open({
        animation: true,
        size: "md",
        templateUrl: "view/modal/delete.html",
        backdrop: "static",
        controller: "DeleteModalController",
        resolve: {
          itemToBeDeleted() {
            return data;
          },
          itemType() {
            return type;
          },
        },
      });

      const createModal = (template, controller, resolve, size = "lg") => $modal.open({
        animation: true,
        backdrop: "static",
        templateUrl: `view/modal/${template}.html`,
        controller,
        resolve,
        size,
      });

      const createConfirmationModal = (title, bodyContent) => createModal(
        "confirmation",
        "ConfirmationController",
        {
          title: () => title,
          bodyContent: () => bodyContent,
        },
        "md",
      );

      return {
        openDelete,
        createModal,
        createConfirmationModal,
      };
    },
  ]);
